import { Chip, Stack, Tooltip } from '@chronosphereio/chrono-ui';
import { getDurationFromTimeRangeStart, getFormattedDateTimeRange } from '@chronosphereio/core';
import { useCallback, useMemo } from 'react';
import { useTimeZone } from '@/components';
import { useTimeRange } from '@/plugin-system/runtime';
import { useUserTimeFormat } from '@/plugin-system/runtime/useUserTimeFormat';

export const OVERRIDE_BAR_HEIGHT = 24;

export const VizPanelTimeOverrideBar = ({
  relativeTimeAdornment,
  onRemoveRelativeTime,
}: {
  relativeTimeAdornment?: React.ReactNode;
  onRemoveRelativeTime?: () => void;
}) => {
  const handleRemoveRelativeTime = useCallback(() => {
    if (onRemoveRelativeTime) {
      onRemoveRelativeTime();
    }
  }, [onRemoveRelativeTime]);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {relativeTimeAdornment ? <>{relativeTimeAdornment} </> : null}
      <RemovableRelativeTimeChip onRemoveRelativeTime={onRemoveRelativeTime ? handleRemoveRelativeTime : undefined} />
    </Stack>
  );
};

const RemovableRelativeTimeChip = ({ onRemoveRelativeTime }: { onRemoveRelativeTime?: () => void }) => {
  const { timeZone } = useTimeZone();
  const { absoluteTimeRange, timeRange } = useTimeRange();
  const timeFormat = useUserTimeFormat();

  // Get resolved absolute time tooltip content
  const formattedTimeRangeWithTimeZone = useMemo(() => {
    return getFormattedDateTimeRange({
      startDate: absoluteTimeRange.start.toString(),
      endDate: absoluteTimeRange.end.toString(),
      timeZone,
      timeFormat,
    });
  }, [absoluteTimeRange.start, absoluteTimeRange.end, timeZone, timeFormat]);

  const pastDuration = getDurationFromTimeRangeStart(timeRange);
  const infoBadgeContent = pastDuration ? pastDuration : formattedTimeRangeWithTimeZone;

  return infoBadgeContent ? (
    <Tooltip Content={infoBadgeContent}>
      <Chip sx={{ overflow: 'hidden' }} label={infoBadgeContent} onDelete={onRemoveRelativeTime} />
    </Tooltip>
  ) : null;
};
